export interface ThemeDef {
  id: string;
  label: string;
  swatch: string;
}

export const THEMES: ThemeDef[] = [
  { id: "ink", label: "墨黑", swatch: "linear-gradient(135deg,#000,#262626)" },
  { id: "paper", label: "紙白", swatch: "linear-gradient(135deg,#fff,#d8d8d8)" },
];

const KEY = "lunyu-theme";

export function loadTheme(): string {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored && THEMES.some((t) => t.id === stored)) return stored;
  } catch {
    /* ignore */
  }
  return "ink";
}

export function applyTheme(id: string): void {
  if (typeof document !== "undefined") document.documentElement.dataset.theme = id;
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* ignore */
  }
}

export function initTheme(): void {
  applyTheme(loadTheme());
}
